import { render, staticRenderFns } from "./drawerDescribe.vue?vue&type=template&id=7ce67fde&"
import script from "./drawerDescribe.vue?vue&type=script&lang=js&"
export * from "./drawerDescribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports